<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-3 pt-5 pt-md-8">     
    </base-header>
    <div class="board-container">
      <div class="board">
        <div class="lists-container">
          <Container
          lock-axis="x"
          orientation="horizontal"
          drag-handle-selector=".list-drag-handle"
          @drop="onListDrop"
        >
          <Draggable v-for="(list, listIndex) in lists" :key="list._id">
            <section class="list-container" ref="list" :data-id="list._id">

              <div class="list-header">
                <span class="list-drag-handle">&#x2630;</span>
                {{ list.title }}
              </div>
              
              <Container
                group-name="list"
                drag-class="card-ghost"
                drop-class="card-ghost-drop"
                non-drag-area-selector=".icon"
                :animation-duration="100"
                @drop="e => onCardDrop(e, list, listIndex)"
              >
                <Draggable v-for="item in list.items" :key="item._id">
                  <Card :item="item" v-show="item.listID === list._id" @edit="editTask(item)" />
                </Draggable>

              </Container>

              <div class="item-entry">
                <ui-item-entry :list-id="list._id"
                               placeholder="Add an item"
                               icon="ellipsis-h"
                               @enter="addItem"/>
              </div>

            </section>
          </Draggable>
          
          <div class="new-list">
            <base-input class="input-group-alternative"
                  placeholder="Add an List"
                  addon-right-icon="ni ni-app" v-model="newlist" @keydown.enter="addList">
            </base-input>
          </div>
          </Container>
        </div>
      </div>
    </div>
    <modal :show.sync="modal">
      <template slot="header">
        <h3 class="modal-title">Công Việc</h3>
      </template>
      <div class="row">
        <h5>Khởi tạo: {{curtask.owner}}</h5>
      </div>
      <div class="row">
        <div class="col pl-0">
          <h5>Cập Nhật: {{curtask.updateBy}}</h5>
        </div>
        <div class="col pl-0">
          <h5>Lúc: {{ formattime(curtask.updateAt) }}</h5>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-3 pl-0">
          <h5>Tiêu Đề</h5>
        </div>
        <div class="col pl-0">
          <base-input  v-model="curtask.title"></base-input>
        </div>
      </div>
      <div class="row">
        <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" placeholder="Chi tiết công việc ..." v-model="curtask.context"></textarea>
      </div>
      <div class="row">
        <slot>Thời gian</slot>
        <base-input addon-left-icon="ni ni-calendar-grid-58">
          <flatPickr slot-scope="{focus, blur}"
            @on-open="focus"
            @on-close="blur"
            :config="{allowInput: true, dateFormat:'Y-m-d H:i', enableTime:true, time_24hr: true}"
            class="form-control datepicker"
            v-model="curtask.beginDate">
          </flatPickr>
        </base-input>
      </div>
      <template slot="footer">
        <base-button type="info" class="btn-sm" @click="cancelTask">Hủy</base-button>
        <base-button type="primary" class="btn-sm" @click="saveTask">Lưu</base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Container, Draggable } from 'vue-smooth-dnd'
import { makeDropHandler } from '../../utils/plugins'
import Card from './Card'
import UiItemEntry from '../../utils/UiItemEntry'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
export default {
  components: {
    Container,
    Draggable,
    Card,
    UiItemEntry,
    flatPickr,
  },
  data: ()=> {
    return {
      modal: false,
      newlist: "",
      lists: [],
      curtask: {},
    }
  },
  methods: {
    onListDrop: makeDropHandler('onListDropComplete'),

    onListDropComplete: function (src, trg) {
      this.lists.splice(src.index, 0, this.lists.splice(trg.index, 1)[0])
    },

    onCardDrop: makeDropHandler('onCardDropComplete'),

    async onCardDropComplete (src, trg) {
        const fromIndex = src.index
        const fromListId = src.params[1]
        const toListId = trg.params[1]
        const toIndex = trg.index
        let item = this.lists[fromListId].items.splice(fromIndex,1)[0]
        item.listID = this.lists[toListId]._id     
        this.lists[toListId].items.splice(toIndex,0,item)
        let data = { listId: item.listID, taskId: item._id }
        await this.$http.post('/task/move', data)
    },
    getListById(id) {
      for(let i=0;i< this.lists;i+=1) {
        if(this.lists[i]._id === id) {
          return i
        }
      } 
    },

    async addList() {
      let data = { title: this.newlist}
      let res = await this.$http.post('/list/add', data)
      this.lists.push(res.data)
      this.newlist =""
    },

    async addItem({id,text}){
      let data = { listID: id, title: text }
      let res = await this.$http.post('/task/add', data)
      for(let i =0 ; i< this.lists.length; i+=1){
        if(this.lists[i]._id === id){
          let list = this.lists[i]
          list.items.push(res.data)
          this.$set(this.lists, i,list)
        }
      }
      
    },

    async getLists(){
      let res = await this.$http.get('/list')
      let lists =      res.data
      let resq = await this.$http.get('/task')
      let items = resq.data
      for(let i=0;i<lists.length;i++){
        let ritems = []
        for(let j=0;j<items.length;j+=1){
          if(lists[i]._id === items[j].listID){
            ritems.push(items[j])
          }
        }
        lists[i].items = ritems
      }
      this.lists = lists
    },
    editTask(task) {
      this.curtask = task
      this.modal = true
    },
    cancelTask() {
      this.curtask = {}
      this.modal = false
    },
    async saveTask() {
      let data = this.curtask
      for(let i =0 ; i< this.lists ;i+=1) {
        if(this.lists[i]._id === data.listID){
          let list = this.lists[i]
          let items = list.items
          for(let j=0;j<items.length;j+=1) {
            if(items[j]._id === data._id){
              items[j] = data
              list.items = items
              this.$set(this.lists, i, list)
            }
          }
        }
      }
      await this.$http.post('/task/edit', data)
      this.curtask = {}
      this.modal =false
    },
    formattime(curdate) {
        if(curdate){
          return this.$moment.tz(curdate,"Asia/Ho_Chi_Minh").format("DD/MM/YYYY HH:mm")
        }
    },
  },
  mounted() {
    this.getLists()
  }
}
</script>
<style lang="scss">
  .board {
    margin-top: 20px;
    white-space: nowrap;
    > * {
      display: inline-block;
    }
    .new-list {
      margin-top: 10px;
    }
  }
  $column-width: 320px;

  .list-container {
    width: $column-width;
    padding: 10px;
    margin: 5px;
    margin-right: 20px;
    background-color: #f3f3f3;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12), 0 1px 1px rgba(0, 0, 0, 0.24);
  }

  .lists-container {
    > * {
      display: inline-block;
      vertical-align: top;
    }
  }
  .list-header {
    margin-bottom: 5px;
  }
   .list-drag-handle {
    cursor: move;
    padding: 5px;
  }
    .item-entry {
    padding-top: 10px;
    margin-top: 10px;
    border-top: 1px solid #DDD;
  }
    .new-list {
    width: $column-width;
    margin-left: -10px;
  }
  .card-ghost {
    transition: 0.25s all;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.12);
    transform: scale(1.1);
  }

  .card-ghost-drop {
    transform: scale(1);
  }

</style>